export const AttachmentSource = Object.freeze({
  GALLERY: "GALLERY",
  CAMERA: "CAMERA",
});
